import { z } from 'zod';
import { UserRoleSchema } from './common';

export const LoginRequestSchema = z.object({
  email: z.string().email().max(256),
  password: z.string().min(1).max(256),
});
export type LoginRequest = z.infer<typeof LoginRequestSchema>;

export const RegisterRequestSchema = z.object({
  email: z.string().email().max(256),
  name: z.string().min(1).max(128),
  role: UserRoleSchema.default('ESTIMATOR'),
});
export type RegisterRequest = z.infer<typeof RegisterRequestSchema>;

export const ForgotPasswordRequestSchema = z.object({
  email: z.string().email(),
});
export type ForgotPasswordRequest = z.infer<typeof ForgotPasswordRequestSchema>;

export const ResetPasswordRequestSchema = z.object({
  token: z.string().min(32).max(256),
  newPassword: z.string().min(8, 'Password must be at least 8 characters').max(256),
});
export type ResetPasswordRequest = z.infer<typeof ResetPasswordRequestSchema>;

export const UserSchema = z.object({
  id: z.string(),
  email: z.string().email(),
  name: z.string(),
  role: UserRoleSchema,
  companyId: z.string(),
  createdAt: z.string(),
  lastLoginAt: z.string().nullable(),
});
export type User = z.infer<typeof UserSchema>;

export const SessionSchema = z.object({
  user: UserSchema,
  expiresAt: z.string(),
});
export type Session = z.infer<typeof SessionSchema>;
